// extracted by mini-css-extract-plugin
export default {"icon":"_3Haix","iconWithoutBackground":"_1iLkC","background":"Xb3kc"};